var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCloseDeliveryFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 4a1 1 0 0 1 1-1h15c.493 0 1.211.14 1.834.588C20.51 4.074 21 4.874 21 6v12c0 .493-.14 1.211-.588 1.834C19.926 20.51 19.126 21 18 21H7c-.445 0-1.122-.094-1.725-.42C4.628 20.23 4 19.562 4 18.5v-4a1 1 0 0 1 1-1h.5a.75.75 0 0 0 0-1.5H3a1 1 0 1 1 0-2h5.5a.75.75 0 0 0 0-1.5H4a1 1 0 0 1 0-2h4.5a.75.75 0 0 0 0-1.5H3a1 1 0 0 1-1-1m10.121 5.707a1 1 0 0 0-1.414 1.414l1.414 1.415-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414 1.415 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414 1.414-1.415a1 1 0 0 0-1.414-1.414l-1.415 1.414z",
  clipRule: "evenodd"
})));
export default SvgGemCloseDeliveryFilled;